import StvAnrede from "./StvAnrede";
import StvJaNeinUnbekannt from "./StvJaNeinUnbekannt";
import StvTitel from "./StvTitel";

export default class FormAntragDto {
    vnAnrede?: StvAnrede;

    vnTitel?: StvTitel;

    vnName?: string;

    vnVorname?: string;

    vnGeburtsdatum?: string;

    // *** Anschrift
    vnAnschriftStrasse?: string;

    vnAnschriftHsnr?: string;

    vnAnschriftPlz?: string;

    vnAnschriftOrt?: string;

    // *** Kommunikation
    vnKommEmailPrivat?: string;

    vnKommHandyPrivat?: string;

    // *** Produkt (DD.MM.YYYY)
    produktVsBeginn?: string;

    // *** Bankverbindung    
    bankIban?: string;

    // *** OptIn
    optInMail?: boolean;

    optInTelefon?: boolean;

    optInSms?: boolean;

    // *** Vorschaden
    vorschaden?: StvJaNeinUnbekannt;

    vorschadenFreitext?: string;

}